import * as crypto from 'crypto'

const generateKey = () => {
    return crypto.randomBytes(4).toString('hex') + '-' + crypto.randomBytes(4).toString('hex') + '-' + crypto.randomBytes(4).toString('hex')
}

export {
    generateKey
}